import { TabProps } from '@Components/tab/view';
import { KnowledgeProps } from './props';
import golf0 from '@Images/golf0.webp';
import golf1 from '@Images/golf1.webp';
import golf2 from '@Images/golf2.webp';
import golf3 from '@Images/golf3.webp';
import golf4 from '@Images/golf4.webp';
import golf5 from '@Images/golf5.webp';
import golf6 from '@Images/golf6.webp';
import golf7 from '@Images/golf7.webp';
import golf8 from '@Images/golf8.webp';
import golf9 from '@Images/golf9.webp';
import golf10 from '@Images/golf10.webp';
import golf11 from '@Images/golf11.webp';
import golf12 from '@Images/golf12.webp';
import golf13 from '@Images/golf13.webp';
import golf14 from '@Images/golf14.webp';
import golf15 from '@Images/golf15.webp';
import golf16 from '@Images/golf16.webp';
import golf17 from '@Images/golf17.webp';
import golf18 from '@Images/golf18.webp';
import golf19 from '@Images/golf19.webp';
import golf20 from '@Images/golf20.webp';
import golf23 from '@Images/golf23.webp';

export const tabs: TabProps[] = [
    {
        key: 'knowledge',
        name: 'ゴルフ会員権の基礎知識',
        url: '/knowledge',
    },
    {
        key: 'faq',
        name: 'よくあるご質問',
        url: '/faq',
    },
];

export const KnowledgeList: KnowledgeProps[] = [
    {
        id: 1,
        image: golf0,
        title: 'ゴルフ会員権デビュー',
        description: 'ゴルフ会員権は、たくさんの喜びとチャンスを与えてくれます。',
    },
    {
        id: 2,
        image: golf1,
        title: 'ゴルフ会員権の仕組み',
        description:
            'ひとくちにゴルフ会員権と言ってもその発行形態は多様です。\nそこでその仕組みや相場、購入から入会に至るまでを以下に簡単に説明いたします。',
    },
    {
        id: 3,
        image: golf2,
        title: '名義書換に関して',
        description:
            'ゴルフ会員権を購入した場合や、法人会員権の利用者が変わった場合、旧名義人から名義を変更しなければメンバーとして登録されず、施設利用権や様々なサービスを受ける権利が発生しません。\nここでは、名義書換について、そしてその料金や会計処理、相続について簡単に解説いたします。',
    },
    {
        id: 4,
        image: golf3,
        title: '預託金に関して',
        description:
            '日本のゴルフ場の会員制ゴルフクラブは大きく分け、預託金会員制、株主会員制、社団法人制の３種類があり、約８割のゴルフ場が預託金会員制度です。ここでは、預託金とはどういうものか、ゴルフ会員権との関係性、預託金返還をめぐる問題についてご紹介していきます。',
    },
    {
        id: 20,
        image: golf17,
        title: 'ゴルフ会員権の購入について',
        description:
            'ゴルフ会員権をこれから購入する方向けに、相場の調べ方から購入先の探し方、名義書換の手続き、購入時にかかる費用や税金の注意点までを事例を交えてご説明します。',
    },
    {
        id: 19,
        image: golf18,
        title: 'ゴルフ会員権の売却について',
        description:
            'ゴルフ会員権を手放したい方向けに、売却の流れやトラブル回避のポイント、売却にかかる手数料・税金の処理方法、成功事例や失敗事例までを詳しくご説明します。',
    },
    {
        id: 5,
        image: golf4,
        title: 'ゴルフ会員権の会計処理',
        description:
            '会計基準が厳格化されるに従い、ゴルフ会員権を売買した時以外も、時価の評価により含み益・含み損を明確にして資産の過少計上や過大計上を避けて健全な会計処理が求められるようになりました。\nここではゴルフ会員権の基礎知識と会社の会計処理までを簡単に解説します。',
    },
    {
        id: 6,
        image: golf5,
        title: 'ゴルフ会員権の相続',
        description:
            'ゴルフ会員権は相続税の対象になります。\n相続税評価額の算出方法、名義変更の流れ、売却時における必要書類、譲渡所得についてご説明いたします。',
    },
    {
        id: 7,
        image: golf6,
        title: '消費税に関して',
        description:
            'ゴルフクラブが発行するゴルフ会員権には預託金をゴルフ場会社に預ける預託形態のものと、会員一人一人が株主となる株式形態のものと２種類ありますが、基本的には形態の相違により消費税の課税関係が異なることはありません。',
    },
    {
        id: 8,
        image: golf7,
        title: 'ゴルフ会員権とは？基礎知識とメリット・デメリットを解説',
        description:
            'メンバーになることにより、その後のゴルフライフが更に充実したものになる人が多くいらっしゃると思いますが、中には負担に感じる方もいらっしゃるかもしれません。\nそこで、「ゴルフ会員権とは何か？」を仕組みやメリットを含めて分かりやすく解説します。',
    },
    {
        id: 9,
        image: golf8,
        title: 'ゴルフ会員権の損益通算',
        description:
            'ゴルフ会員権は、購入時の価格よりも売却時の価格が下回り、売却損が発生した場合には損益通算による控除が可能でしたが個人の場合においては２０１４年４月以降、ゴルフ会員権の売却によって損失が発生したとしても損益通算できなくなったため、ゴルフ会員権の売却については一考の必要が出てきました。\nこの記事では、損益通算とは？という基本的なことから、ゴルフ会員権が損益通算の控除対象外となってしまった経緯、より有利な条件で売却するためのポイントについて解説します。',
    },
    {
        id: 10,
        image: golf9,
        title: '評価損の計上方法',
        description:
            '会計業務において、ゴルフ会員権の評価額は計算方法が細かく分けられており、頭を悩ませてはいないでしょうか。\n法人で保有するゴルフ会員権の評価損は会員権自体の実体がないため、慣れていなければ計算方法のイメージもしづらく、さらには評価損や貸倒を計上するタイミングによって税務上の取り扱いも変わってしまうため、混乱しやすくなります。\nこの記事では、ゴルフ会員権の評価損の計上方法や貸倒処理について、ケースごとに掘り下げて解説していきます。',
    },
    {
        id: 11,
        image: golf10,
        title: '年会費について',
        description:
            'ゴルフ会員権に毎年発生する年会費の仕組みや取り扱いについて、きちんと理解されていますでしょうか。\nこの記事では、ゴルフ会員権の税務上の扱いから、年会費が払えない場合の対処法まで、年会費にまつわる内容を紹介しています。\n法人の経理担当の方はもちろん、ゴルフ会員権をお持ちのすべての方が知っていて損はない内容となっているので、ぜひご参考にしてください。',
    },
    {
        id: 12,
        image: golf11,
        title: 'ローンに関して',
        description:
            'ゴルフ会員権の購入を検討しているものの、高額な会員権を一括で購入する難しさから購入を諦めてしまう方がいらっしゃいます。\nそんな方におすすめなのが、ローンを組んでのゴルフ会員権購入です。\nただ、数十万円～百万円、中には数千万円するゴルフ会員権でローン契約を結ぶのは手放しにおすすめ出来るわけではありません。\nこの記事ではゴルフ会員権のローンについて詳しくご紹介しますので、ローンでのゴルフ会員権購入を検討されている方は是非参考にしてください。',
    },
    {
        id: 13,
        image: golf12,
        title: 'ゴルフ会員権を安く買う方法は？ご入会にかかる総額について',
        description:
            'ゴルフ会員権は決して安い買い物ではありませんので、失敗したくないものです。\nこの記事では、ゴルフ会員権の相場や会員権以外に必要な費用、ゴルフ会員権取扱業者の選び方についてご紹介します。\nこれからゴルフ会員権の購入をご検討されている方はぜひご参考ください。',
    },
    {
        id: 14,
        image: golf13,
        title: '法人のゴルフ会員権とは？記名式と無記名式の違いについても解説',
        description:
            'ゴルフ会員権には無記名式と記名式がありますが、この記事ではゴルフ会員権の法人無記名式と記名式との違いや法人会員権を持つメリット・デメリットなどをご紹介します。\n法人無記名式のゴルフ会員権の購入を検討されている方や、法人会員権の売買を検討している方は、ぜひ参考にしてください。',
    },
    {
        id: 15,
        image: golf14,
        title: 'ゴルフ会員権の退会について',
        description:
            '「最近ゴルフに行く回数が減ってきたから退会したい」\n「他のゴルフ場の会員権に買い替えたい」\nこういった悩みをお持ちではないでしょうか。\nゴルフ会員権を手放すには、売却と退会届を出す2種類の方法があり、多くの場合では売却がおすすめです。\nこの記事では、ゴルフ会員権の退会方法について詳しくご紹介します。',
    },
    {
        id: 16,
        image: golf15,
        title: '預託金の償還',
        description:
            '預託金制を採用しているゴルフ場の会員権を新規購入する際には、ゴルフ場が設定する預け入れ金が必要となり、これを預託金と呼びます。\nこの記事では、ゴルフ会員権の預託金についてご紹介するとともに、預託金償還問題などのトラブルやその解決方法までを解説していきます。\nゴルフ会員権の預託金に関する問題でお悩みの方をはじめ、ゴルフ会員権の購入を検討している方は、ぜひご参考にしてください。',
    },
    {
        id: 17,
        image: golf16,
        title: '面接に関して',
        description:
            'ゴルフ場の会員になると予約が優先的に取れたり、グリーンフィーが割安となったりするなど、ビジターにはない特典を利用出来ますが、お金を払えば誰でもゴルフ場の会員になれるわけではありません。\nゴルフ場によっては面接が必要となる場合があり、会員としてふさわしいかを認めてもらわなければいけないことを理解しておきましょう。',
    },
    {
        id: 18,
        image: golf17,
        title: '推薦状の文例',
        description:
            'ゴルフ会員権を購入し、入会審査を受けるにあたり、そのゴルフ場の会員からの推薦状が必要になる場合があります。\nゴルフ会員権を初めて購入しようと思った時に、推薦状を依頼する相手がいないという点でつまずいてしまう方もいます。\nこの記事では、ゴルフ会員権取得時に必要となる推薦状について、推薦状の文例や推薦人に対する御礼状の文例などをご紹介します。',
    },
    {
        id: 21,
        image: golf19,
        title: 'PGMグループのゴルフ会員権のメリットは？おすすめのコースも紹介',
        description:
            'PGMグループのゴルフ会員権は、P-CAPという多彩な会員特典プログラムや、預託金充当の制度があります。PGMグループのゴルフ会員権を購入するメリットとともにいくつかのおすすめコースを紹介します。',
    },
    {
        id: 22,
        image: golf20,
        title: 'リゾートトラストグループのゴルフ会員権のメリットは？おすすめのコースも紹介',
        description:
            'リゾートトラストグループのゴルフ会員権は、グループゴルフ場の相互利用やリゾートトラストホテルの利用などのメリットもあります。リゾートトラストグループのゴルフ会員権を購入するメリットとともにいくつかのおすすめコースを紹介します。',
    },
    {
        id: 23,
        image: golf23,
        title: '太平洋クラブの共通会員権のメリットは？おすすめのコースも紹介',
        description:
            '太平洋クラブのゴルフ会員権は、国内18コースはもちろん、海外の提携クラブで優待が受けられる共通会員権です。太平洋クラブのゴルフ会員権を購入するメリットとともにいくつかのおすすめコースを紹介します。',
    },
    {
        id: 24,
        image: golf12,
        title: '無記名式ゴルフ会員権とは？記名式との違いやメリット・デメリットを解説',
        description:
            '無記名式ゴルフ会員権とは、それを保有する法人に属する人であれば誰でも利用できる会員権のことです。この記事では、無記名式が減った理由や記名式との違い、メリット・デメリット、購入・売却時の注意点について詳しくご紹介します。',
    },
    {
        id: 25,
        image: golf12,
        title: 'ゴルフ会員権の全国相場データ・価格動向の見方',
        description:
            'ゴルフ会員権の価格は10万円以下のものから4,000万円を超えるものまで幅広く存在します。この記事では、価格を左右する主な要因と、エリア別の相場動向を把握するためのポイントをご紹介します。',
    },
    {
        id: 26,
        image: golf1,
        title: '関東エリアのゴルフ会員権相場動向',
        description:
            '首都圏からの距離や歴史あるクラブの集積など、関東エリアならではのゴルフ会員権の相場傾向を解説します。エリアで会員権を検討する際の注意点もあわせてご紹介します。',
    },
    {
        id: 27,
        image: golf3,
        title: '関西・近畿エリアのゴルフ会員権相場動向',
        description:
            '大阪・神戸都市圏の利便性や老舗クラブの存在感など、関西・近畿エリアのゴルフ会員権相場の特徴を解説します。エリアで会員権を検討する際の注意点もあわせてご紹介します。',
    },
    {
        id: 28,
        image: golf8,
        title: '中部・東海エリアのゴルフ会員権相場動向',
        description:
            '製造業の集積を背景とした法人需要など、中部・東海エリアならではのゴルフ会員権の相場傾向を解説します。エリアで会員権を検討する際の注意点もあわせてご紹介します。',
    },
    {
        id: 29,
        image: golf11,
        title: '九州・沖縄エリアのゴルフ会員権相場動向',
        description:
            '福岡都市圏の需要や温暖な気候を活かしたリゾート型コースなど、九州・沖縄エリアのゴルフ会員権相場の特徴を解説します。エリアで会員権を検討する際の注意点もあわせてご紹介します。',
    },
    {
        id: 30,
        image: golf19,
        title: '名門・高額帯クラブの相場動向',
        description:
            '歴史の長さや会員数を絞った運営方針など、いわゆる名門クラブに共通する特徴と、高額帯クラブの相場を動かす要素を解説します。',
    },
    {
        id: 31,
        image: golf20,
        title: '相場が上下する会員権の見分け方',
        description:
            '預託金の据置期間や運営会社の経営状態など、今後相場が上がりやすい会員権・下がりやすい会員権を見分けるためのチェックポイントを解説します。',
    },
    {
        id: 32,
        image: golf10,
        title: '年会費の勘定科目・経費算入の可否',
        description:
            'ゴルフ会員権の年会費をどの勘定科目で処理すべきか、法人・個人事業主それぞれの経費算入の可否について、通達に基づいて具体的に解説します。',
    },
    {
        id: 33,
        image: golf6,
        title: 'ゴルフ会員権売却時の消費税・仕訳（法人・個人別）',
        description:
            'ゴルフ会員権を売却する際の消費税の課否判定と、法人・個人それぞれのケースでの具体的な仕訳例を解説します。',
    },
    {
        id: 34,
        image: golf5,
        title: 'ゴルフ会員権の相続税評価・計算方法（具体例つき）',
        description:
            '財産評価基本通達に基づくゴルフ会員権の相続税評価方法を、取引相場の有無や会員権の形態ごとに、具体的な計算例とあわせて解説します。',
    },
    {
        id: 35,
        image: golf13,
        title: 'ゴルフ会員権の贈与（生前贈与時の評価・注意点）',
        description:
            'ゴルフ会員権を生前贈与する際の評価方法や、暦年課税・相続時精算課税制度の考え方、名義書換の手続きについて解説します。',
    },
    {
        id: 36,
        image: golf2,
        title: '名義書換料の勘定科目・仕訳完全ガイド',
        description: '名義書換料を支払う場面ごとの勘定科目の考え方と、法人・個人それぞれの具体的な仕訳例を解説します。',
    },
    {
        id: 37,
        image: golf9,
        title: 'ゴルフ会員権の減損・評価損の判定基準',
        description:
            '会計上・税務上それぞれの視点から、ゴルフ会員権の評価損（減損）を検討すべき判定基準を整理して解説します。',
    },
    {
        id: 38,
        image: golf1,
        title: '東急ゴルフリゾートのゴルフ会員権とは？特典やおすすめコースを紹介',
        description:
            '東急ゴルフリゾートは、東急不動産ホールディングスグループが運営する関東・東北エリアのゴルフ場です。ゴルフ場特別優待やリゾートホテル優待など、東急ゴルフリゾートのゴルフ会員権の特典をご紹介します。',
    },
    {
        id: 39,
        image: golf2,
        title: '小田急グループのゴルフ会員権とは？富士小山ゴルフクラブを解説',
        description:
            '小田急グループのゴルフ会員権は、静岡県の富士小山ゴルフクラブが中心です。会員権の形態や特徴について詳しくご紹介します。',
    },
    {
        id: 40,
        image: golf3,
        title: '藤田観光グループのゴルフ会員権とは？カメリアヒルズカントリークラブを解説',
        description:
            '藤田観光グループのゴルフ会員権は、女子プロトーナメント開催コースであるカメリアヒルズカントリークラブが中心です。コースの特徴について詳しくご紹介します。',
    },
    {
        id: 41,
        image: golf4,
        title: 'リソルグループのゴルフ会員権のメリットは？おすすめのコースも紹介',
        description:
            'リソルグループのゴルフ会員権は、リソルカードGという共通ポイント制度が特徴です。リソルグループのゴルフ会員権を購入するメリットとともにいくつかのおすすめコースを紹介します。',
    },
    {
        id: 42,
        image: golf5,
        title: 'アコーディア・ゴルフグループのゴルフ会員権とは？おすすめのコースも紹介',
        description:
            'アコーディア・ゴルフグループは全国172コースを運営する国内最大級のゴルフ場グループです。会員権選びのポイントとおすすめのコースをご紹介します。',
    },
    {
        id: 43,
        image: golf20,
        title: 'エクシブとは？リゾートトラストのゴルフ会員権との関係を解説',
        description:
            'エクシブは、リゾートトラストが運営する会員制リゾートホテルブランドです。ゴルフ会員権を持つことでエクシブを優待利用できる仕組みや条件について詳しくご紹介します。',
    },
    {
        id: 44,
        image: golf6,
        title: 'リゾート会員権とは？仕組みや検討時の注意点を解説',
        description:
            'リゾート会員権とは、リゾートホテルやリゾート施設を会員向けの条件で利用できる権利で、ゴルフ会員権とは別の仕組みです。ゴルフ場を利用できる優待が付くケースもあります。仕組みや注意点を解説します。',
    },
    {
        id: 45,
        image: golf19,
        title: 'PGMグループのエリア別優待制度とは？P-CAPを活用したコースの選び方',
        description:
            'PGMグループは全国140以上のゴルフ場を保有しています。P-CAPの優待料金プログラムを活用したエリア別のコースの選び方をご紹介します。',
    },
    {
        id: 50,
        image: golf14,
        title: '記名式会員権とは',
        description:
            '記名式ゴルフ会員権とは、登録された特定の人物しか利用できない会員権のことです。記名式の種類やメリット・デメリット、無記名式との違いについて詳しくご紹介します。',
    },
    {
        id: 51,
        image: golf16,
        title: '入会審査に落ちる理由と対策',
        description:
            'ゴルフ会員権の入会審査に落ちてしまう主な理由と、落ちないための事前対策について詳しく解説します。一度落ちてしまった場合の対応もあわせてご紹介します。',
    },
    {
        id: 52,
        image: golf17,
        title: '推薦者がいない場合の入会方法',
        description:
            '入会に推薦者が必要なゴルフ場で、身近に推薦者がいない場合の対処法をご紹介します。会員権業者への相談や推薦者不要のゴルフ場選びなど、具体的な選択肢を解説します。',
    },
    {
        id: 53,
        image: golf18,
        title: '入会動機書の書き方・例文',
        description:
            'ゴルフ会員権の入会審査で提出を求められることがある入会動機書の書き方と文例を、書くべき内容・注意点とあわせて詳しくご紹介します。',
    },
    {
        id: 54,
        image: golf15,
        title: '紹介者へのお礼マナー',
        description:
            'ゴルフ会員権の入会にあたって紹介・推薦をしてくれた相手へのお礼のタイミングや方法、気をつけたいマナーについて詳しく解説します。',
    },
    {
        id: 55,
        image: golf7,
        title: 'メンバーフィーとは',
        description:
            'メンバーフィーとは会員がプレー当日に支払う1回あたりの料金のこと。ビジターフィーや年会費、預託金との違いを整理してわかりやすく解説します。',
    },
    {
        id: 56,
        image: golf4,
        title: '預託金の償還請求とは',
        description:
            '預託金の据置期間満了後に行う償還請求の具体的な流れと、注意すべきポイントについて詳しく解説します。',
    },
];
